import { Component, OnInit } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { DateHelper } from '../../../helpers/DateHelper';
import { TripPayment } from '../../../models/trips/trip.payment';
import { TripPaymentService } from '../../../services/trip-payment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../../services/alert.service';
import { Helper } from '../../../helpers/Helper';
import { CustomValidators } from '../../../validators/customValidators';
import { MatDialog } from '@angular/material/dialog';
import { TripPaymentDepositConfirmationDialogComponent } from '../trip-payment-deposit-confirmation-dialog/trip-payment-deposit-confirmation-dialog.component';

@Component({
	selector: 'app-trip-payment-form',
	templateUrl: './trip-payment-form.component.html',
	styleUrls: ['./trip-payment-form.component.css']
})
export class TripPaymentFormComponent implements OnInit {
	form: FormGroup;
	tripPayment: TripPayment = new TripPayment();
	isApprover: boolean = false;

	constructor(
		private _tripPaymentService: TripPaymentService,
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		private _alertService: AlertService,
		private _dialog: MatDialog
	) { }

	ngOnInit() {
		this.isApprover = Helper.isManager();

		let id = this._activatedRoute.snapshot.params['id'];
		this.tripPayment = new TripPayment();
		this.tripPayment.id = id;


		if (id == 0) {
			this.tripPayment.id = 0;
			this.tripPayment.dateRecieved = DateHelper.getDateNowString();

			this.form = this.createForm(this.tripPayment);
		}
		else {
			this.form = this.createForm(this.tripPayment);
			this._tripPaymentService.getTripPayment(id).subscribe(
				result => {
					if (result == undefined) {
						this.tripPayment.id = 0;
					}
					else {
						this.tripPayment = result;
						this.form = this.createForm(this.tripPayment)
					}
				}
			);
		}
	}

	private createForm(tripPayment: TripPayment): FormGroup {
		var formGroup = new FormGroup({
            clientId: new FormControl(tripPayment.clientId),
            tripId: new FormControl(tripPayment.tripId, [
				Validators.required
			]),
			amount: new FormControl(tripPayment.amount, [
				Validators.required,
				CustomValidators.validateCurrency
			]),
			dateRecieved: new FormControl(tripPayment.dateRecieved, [
				Validators.required
			]),
			paymentType: new FormControl(tripPayment.paymentType, [
				Validators.required
			]), 
			remarks: new FormControl(tripPayment.remarks),
			checkDueDate: new FormControl(tripPayment.checkDueDate),			
			isDeposited: new FormControl(tripPayment.isDeposited),
		});

		formGroup.get('paymentType').valueChanges.subscribe(
			paymentType => {
				var remarks = formGroup.get('remarks');
				var dueDate = formGroup.get('checkDueDate');
				if(paymentType == 'CHECK'){
					remarks.setValidators([Validators.required]);
					dueDate.setValidators([Validators.required]);
				}
				else{
					remarks.clearValidators();
					dueDate.clearValidators();
				}

				remarks.updateValueAndValidity();
				dueDate.updateValueAndValidity();
			}
		);

		return formGroup;
	}

	onFormSubmit(formValue) {
		if (!this.form.valid) {
			this._alertService.showError('Invalid form data.');
			return;
		}

		this.tripPayment.tripId = formValue.tripId;
		this.tripPayment.amount = formValue.amount;
		this.tripPayment.dateRecieved = formValue.dateRecieved;
		this.tripPayment.paymentType = formValue.paymentType;
		this.tripPayment.remarks = formValue.remarks;
		this.tripPayment.checkDueDate = formValue.checkDueDate;
		this.tripPayment.isDeposited = formValue.isDeposited;

		if (this.tripPayment.id == undefined || this.tripPayment.id == 0) {
			this.create();
		}
		else {
			this.update();
		}
	}

	private create() {
		this._tripPaymentService.addTripPayment(this.tripPayment).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.tripPayment = result.object;
					this._alertService.showSuccess('Payment information has been saved.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
			});
	}

	private update() {
		this._tripPaymentService.updateTripPayment(this.tripPayment).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.tripPayment = result.object;
					this._alertService.showSuccess('Payment information has been updated.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
			});
	}

	isControlInvalid(controlName: string) {
		let control = this.form.controls[controlName];
		return control.invalid && (control.dirty || control.touched);
	}

	onSave() {
		this._dialog.closeAll();
		const formValues = this.form.value;
		
		if(!this.tripPayment.isDeposited && formValues.isDeposited){
			const dialogRef = this._dialog.open(TripPaymentDepositConfirmationDialogComponent, {
				width: "550px"
			});
		  
			dialogRef.afterClosed().subscribe((confirm: boolean) => {
				if (confirm) {				  
					this.onFormSubmit(formValues);
				}
			});			
		}
		else{
			this.onFormSubmit(formValues);
		}		
	}
}



// WEBPACK FOOTER //
// ./src/app/components/trips/trip-payment-form/trip-payment-form.component.ts